import store from "@/store";
import * as Sentry from "@sentry/browser";

export function reportError(message){
    report(message, 'error');
}
export function reportWarning(message){
    report(message, 'warning');
}
function report(message, severity = 'warning'){
    const fullMsg = getMapName() + ' ' + message;
    Sentry.setTag("map", getMapName());
    Sentry.setTag("category", 'health');
    Sentry.captureMessage(fullMsg, severity);
    console[severity] && console[severity](fullMsg);
}

function getMapName(){
    return store.state.map.name || '';
}
